export default __webpack_public_path__ + "static/media/6.dfa5b201.png";